@if (product() && (showCustomerRating() || ratings.length > 0)) {
  <div class="rating-product text-center col-12 mt-3 mt-lg-0">
    <h5>Anmeldelser</h5>
    <div class="review">
      <app-product-rating class="d-flex" [isCustomerRating]=true [product]="product()"
                          [rating]="getCustomerReviewAsRating(product())"></app-product-rating>
    </div>
    @for (rating of ratings; track rating.id) {
      <div class="review">
        <app-product-rating class="d-flex" [product]="product()" [rating]="rating"></app-product-rating>
      </div>
    }
  </div>
}
